<template>
  <div>
    <div class="content">
      <span class="subtitle has-text-weight-bold has-text-info">
        Divisions
      </span>
    </div>

    <div class="level is-mobile">
      <div class="level-left">
        <div class="level-item">
          <span class="has-text-grey has-text-weight-bold">
            View Divisions
          </span>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <b-field>
            <b-switch
              type="is-info"
              v-model="view"
            />
          </b-field>
        </div>
      </div>
    </div>

    <div class="level is-mobile">
      <div class="level-left">
        <div class="level-item">
          <span class="has-text-grey has-text-weight-bold">
            Create Divisions
          </span>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <b-field>
            <b-switch
              type="is-info"
              v-model="create"
            />
          </b-field>
        </div>
      </div>
    </div>

    <div class="level is-mobile">
      <div class="level-left">
        <div class="level-item">
          <span class="has-text-grey has-text-weight-bold">
            Edit Divisions
          </span>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <b-field>
            <b-switch
              type="is-info"
              v-model="edit"
            />
          </b-field>
        </div>
      </div>
    </div>

    <div class="level is-mobile">
      <div class="level-left">
        <div class="level-item">
          <span class="has-text-grey has-text-weight-bold">
            Delete Divisions
          </span>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <b-field>
            <b-switch
              type="is-info"
              v-model="remove"
            />
          </b-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  name: 'PermissionsDivisionsform',

  computed: {
    view: {
      get() {
        return this.$store.state.Permissions.permissions.admin.divisions.view;
      },

      set(value) {
        return this.$store.commit('Permissions/SET_ADMIN_DIVISIONS_VIEW', value);
      },
    },

    create: {
      get() {
        return this.$store.state.Permissions.permissions.admin.divisions.create;
      },

      set(value) {
        return this.$store.commit('Permissions/SET_ADMIN_DIVISIONS_CREATE', value);
      },
    },

    edit: {
      get() {
        return this.$store.state.Permissions.permissions.admin.divisions.edit;
      },

      set(value) {
        return this.$store.commit('Permissions/SET_ADMIN_DIVISIONS_EDIT', value);
      },
    },

    remove: {
      get() {
        return this.$store.state.Permissions.permissions.admin.divisions.delete;
      },

      set(value) {
        return this.$store.commit('Permissions/SET_ADMIN_DIVISIONS_DELETE', value);
      },
    },
  },

};
</script>

<style lang="css" scoped>
</style>
